/**
 * 判断是否为空
 * @param value
 * @returns {Boolean}
 */
function isEmpty(value) {
  return (
    typeof value == "undefined" ||
    null == value ||
    trim(value.toString()) === ""
  );
}

/**
 * 判断是否不为空
 * @param value
 * @returns {Boolean}
 */
function isNotEmpty(value) {
  return !isEmpty(value);
}

/**
 * 去空格
 * @param str
 * @returns {*}
 */
function trim(str) {
  if (typeof str === "string") {
    str = str.replace(/\s+/g, "");
  }
  return str;
}

/**
 * 去左空格
 * @param str
 * @returns {String}
 */
function ltrim(str) {
  if (typeof str === "string") {
    str = str.replace(/^\s*/, "");
  }
  return str;
}

/**
 * 去右空格
 * @param str
 * @returns {String}
 */
function rtrim(str) {
  if (typeof str === "string") {
    str = str.replace(/(\s*$)/g, "");
  }
  return str;
}

/**
 * 截取富文本中的第一张图片 
 */ 
function getRichtextImg(str){
  var data = [];
  str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function (match, capture) {
        data.push(capture);
  });
  return data
}

export { isEmpty, isNotEmpty, trim, ltrim, rtrim,getRichtextImg };



// WEBPACK FOOTER //
// ./src/utils/String.js